export const environment = {
  production: false,
  appVersion: require('../../package.json').version + '-dev',
  mainApiUrl: 'https://mportal-api-development.azurewebsites.net/api/v1.0/',
  signalRUrl: 'https://memberportalfunctions-development.azurewebsites.net/api/negotiate',
  secureMailUrl: "https://secure-mail-api-development.azurewebsites.net/api/v1",
  defaultSlug: 'abc',
  auth0: {
    domain: 'docucentre-nonprod.ca.auth0.com',
    clientId: '5SIDypjMGGjB0KYnWFcUW6PeUXK5zb6E',
    redirectUri: window.location.origin + '/callback',
    audience: '', // Add your API identifier if you have one
    scope: 'openid profile email'
  }
};
import 'zone.js/plugins/zone-error';
